import { formatActionType } from 'app/dealer/shared/higherOrderReducers/withDataRequest/actionTypeFormatters';

import { LISTINGS_BENCHMARK_REDUCER_NAME } from '../constants';

export const ListingsBenchmarkListingsActionTypes = {
  GET_LISTINGS_DATA_SUCCESS: `[${formatActionType(
    LISTINGS_BENCHMARK_REDUCER_NAME,
  )} Listings] SUCCESS`,
  GET_LISTINGS_DATA_ERROR: `[${formatActionType(
    LISTINGS_BENCHMARK_REDUCER_NAME,
  )} Listings] ERROR`,
  DISABLE_LISTINGS_TILE_COUNTUP: `[${formatActionType(
    LISTINGS_BENCHMARK_REDUCER_NAME,
  )} Listings] DISABLE COUNTUP`,
};

/**
 * @constant LISTINGS_PREFIX
 * @description
 * feature cache key prefix
 */
export const LISTINGS_PREFIX = 'listings';
